import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ListViewCellContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'center',
  height: '100%',
  gap: theme.spacing(3),
}));

export const ListViewCellContent = styled(Stack)({
  flexGrow: 1,
});

export const RefuelMetricsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  rowGap: theme.spacing(0.5),
  marginTop: theme.spacing(1),
  textAlign: 'center',
}));
